import React from "react";
import { TFunction } from "i18next";

import { EtkColumn } from "@components/Common/EtkTable";

import UniqueRowSelection from "./components/UniqueRowSelection";
import FidelityRowSwitch from "./components/FidelityRowSwitch";
import CenteredCheckCell from "./components/CenteredCheckCell";

type Params = {
    t: TFunction;
    selectedShopsRows: any[];
    selectedFidelity: any[];
};

export function useEtkColumns({
    t,
    selectedShopsRows,
    selectedFidelity,
}: Params): EtkColumn[] {
    return React.useMemo<EtkColumn[]>(
        () => [
            {
                index: 0,
                header: " ",
                cell: (e) => <UniqueRowSelection {...e} />,
            },
            {
                index: 5,
                header: t("Centralized loyalty"),
                cell: (e) => (
                    <CenteredCheckCell
                        isActive={e.selectedRow[t("State")] === true}
                    />
                ),
                filterable: true,
            },
            {
                index: 6,
                header: t("Action"),
                cell: (e) => (
                    <FidelityRowSwitch
                        element={e}
                        isOneShopClicked={
                            selectedShopsRows.filter(
                                (el: any) => el.subRows !== undefined
                            ).length < 2
                        }
                        selectedFidelity={selectedFidelity}
                    />
                ),
            },
        ],
        // Why: same pattern as the sibling useCustomColumns — deps track
        // i18n + selection only; non-memoized setters from upstream are excluded
        // to keep the column-memo stable.
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [t, selectedShopsRows, selectedFidelity]
    );
}
